import React from 'react'
import { PMPBodySectionItems } from './styledComponent'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'
import { getCasedHeadingTextBasedOnStyleOverrides } from './util'

export default function PrintableInstructions({
  instructionsRef,
  debug,
  debugHighlightStates,
  selectedInstructions,
  styleOverrides,
}) {
  return (
    <PMPBodySectionItems
      borderLeft={styleOverrides?.borderLeft}
      paddingLeft={styleOverrides?.paddingLeft}
      ref={instructionsRef}
      debug={debug}
      debugColor={PRESCRIPTION_COLORS_MAP.instructions?.color}
      debugHighlight={debugHighlightStates?.instructions}
    >
      <span
        style={{
          fontSize: styleOverrides?.headingFontSize
            ? `${styleOverrides?.headingFontSize}px`
            : 'inherit',
          color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
          fontWeight: 600,
        }}
      >
        <strong>
          {getCasedHeadingTextBasedOnStyleOverrides({
            headingText: 'Advised Instructions',
            styleOverrides,
          })}
        </strong>
      </span>
      <ul
        className="d-flex flex-column"
        style={{
          fontSize: styleOverrides?.fontSizePixels
            ? `${styleOverrides?.fontSizePixels}px`
            : 'inherit',
          color: styleOverrides?.color || 'inherit',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          maxWidth: '100%',
        }}
      >
        {selectedInstructions?.map((item, idx) => (
          <li key={idx}>{item?.label}</li>
        ))}
      </ul>
    </PMPBodySectionItems>
  )
}
